module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid main-body fix-bottom",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectCountry",
      "data-backdrop": "static",
      "show": "true",
      "data-keyboard": "false",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog "
  }, [_c('div', {
    staticClass: "modal-content col-sm-offset-2 col-sm-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body ",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "well"
  }, _vm._l((_vm.countriesList), function(country) {
    return _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('a', {
      staticClass: "dropdown-toggle",
      attrs: {
        "href": "javascript:;",
        "data-toggle": "dropdown",
        "role": "button",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      },
      on: {
        "click": function($event) {
          _vm.setCountry(country.CountryId)
        }
      }
    }, [_c('img', {
      staticClass: "img img-rounded",
      staticStyle: {
        "width": "auto",
        "height": "35px",
        "max-height": "5vh"
      },
      attrs: {
        "alt": "Country",
        "src": country.CountryFlag,
        "crossOrigin": "Anonymous"
      }
    }), _vm._v(" "), _c('a', [_c('strong', [_vm._v(" " + _vm._s(country.CountryName))])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.getNewCountry()
      }
    }
  }, [_vm._v("Want your country to be listed?")])])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default paw hidden-xs",
    attrs: {
      "role": "navigation "
    }
  }, [_c('div', {
    staticClass: "container-fluid container-main "
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.routerGoHome()
      }
    }
  }, [_c('span', {
    staticClass: "navbar-brand"
  }, [_c('span', [_c('img', {
    class: {
      'tinted': _vm.active
    },
    attrs: {
      "alt": "Dupaws Home",
      "id": "logo",
      "src": require("./components/Sitters/images/Logo_small.png"),
      "height": "58"
    },
    on: {
      "mouseover": function($event) {
        _vm.active = true
      },
      "mouseleave": function($event) {
        _vm.active = false
      }
    }
  })])])]), _vm._v(" "), (_vm.compUserRole != _vm.admin) ? _c('div', [(!_vm.checkUser) ? _c('ul', {
    staticClass: "nav navbar-nav  navbar-right "
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/findsitters"
    }
  }, [_c('a', {
    staticClass: "hidden-sm navbar-link"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search Sitters")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.checkUser == false) ? _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/login"
    }
  }, [_c('a', [_vm._v("Sign In")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Sitter') ? _c('span', {
    staticClass: "navbar-toggle pull-right bookings-button",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('router-link', {
    staticStyle: {
      "list-style-type": "none"
    },
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/my-sitter-reservations"
    }
  }, [_c('i', {
    staticClass: "icon-fix fa fa-bookmark-o"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client') ? _c('span', {
    staticClass: "navbar-toggle pull-right bookings-button",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('router-link', {
    staticStyle: {
      "list-style-type": "none"
    },
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/my-reservations"
    }
  }, [_c('i', {
    staticClass: "icon-fix fa fa-bookmark-o"
  })])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-right": "0px",
      "margin-left": "5px",
      "padding-left": "0px",
      "outline": "none"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showCountries()
      }
    }
  }, [_c('i', [(_vm.countryDataComp.CountryFlag) ? _c('img', {
    staticClass: "img img-rounded",
    staticStyle: {
      "text-indent": "-9999px",
      "width": "auto",
      "height": "35px",
      "margin-bottom": "5px",
      "outline": "none"
    },
    attrs: {
      "alt": "Countries Selector",
      "src": _vm.countryDataComp.CountryFlag,
      "crossOrigin": "Anonymous"
    }
  }) : _vm._e()])])]), _vm._v(" "), (!_vm.doubleRoleComp) ? _c('router-link', {
    staticClass: "text-success",
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/become-a-sitter"
    }
  }, [_c('a', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(" Become a Sitter  "), _c('i', {
    staticClass: "fa fa-heart-o",
    class: {
      'animated bounceIn': _vm.heartClass
    },
    staticStyle: {
      "font-weight": "600"
    },
    on: {
      "mouseover": function($event) {
        _vm.heartClass = true
      },
      "mouseleave": function($event) {
        _vm.heartClass = false
      }
    }
  })])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkUser),
      expression: "checkUser"
    }],
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.compUserRole != _vm.sitter) ? _c('router-link', {
    staticClass: "hidden-xs hidden-sm",
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/findsitters"
    }
  }, [_c('a', {
    staticClass: "navbar-link"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('router-link', {
    staticClass: "hidden-xs hidden-sm",
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/my-reservations"
    }
  }, [_c('a', {
    staticClass: "navbar-link"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
    staticClass: "hidden-xs hidden-sm",
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/dashboard/feedback-performance"
    }
  }, [_c('a', {
    staticClass: "navbar-link"
  }, [_c('i', {
    staticClass: "fa fa-globe "
  }), _vm._v(" Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
    staticClass: "hidden-xs hidden-sm",
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/my-sitter-reservations"
    }
  }, [_c('a', {
    staticClass: "navbar-link"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (!_vm.checkUser) ? _c('li', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-right": "0px",
      "margin-left": "5px",
      "padding-left": "0px",
      "outline": "none"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showCountries()
      }
    }
  }, [_c('i', [_c('img', {
    staticClass: "img img-rounded",
    staticStyle: {
      "width": "auto",
      "height": "35px",
      "margin-bottom": "5px"
    },
    attrs: {
      "alt": "Flag",
      "src": _vm.countryDataComp.CountryFlag,
      "crossOrigin": "Anonymous"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
    staticClass: "hidden-md hidden-lg bookings-button",
    attrs: {
      "active-class": "active ",
      "tag": "li",
      "to": "/my-sitter-reservations"
    }
  }, [_c('div', {
    staticClass: "icon-fix navbar-link"
  }, [_c('i', {
    staticClass: " fa fa-bookmark-o"
  })])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client') ? _c('router-link', {
    staticClass: "hidden-md hidden-lg bookings-button",
    attrs: {
      "active-class": "active ",
      "tag": "li",
      "to": "/my-reservations"
    }
  }, [_c('div', {
    staticClass: "icon-fix navbar-link"
  }, [_c('i', {
    staticClass: " fa fa-bookmark-o"
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('div', {
    staticClass: "notification-button",
    attrs: {
      "id": "webNotificationDropdown"
    }
  }, [_c('Notifications', {
    attrs: {
      "bindId": _vm.webDropdown
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "dropdown pull-right"
  }, [(_vm.compUserName) ? _c('a', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "margin-left": "3px"
    },
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "img img-rounded",
    staticStyle: {
      "width": "auto",
      "height": "50px",
      "max-height": "5vh"
    },
    attrs: {
      "alt": "User Profile Picture",
      "src": _vm.compProfilePicUrl,
      "crossOrigin": "Anonymous"
    }
  }), _vm._v(" "), _c('a', [_vm._v(" " + _vm._s(_vm.compUserName))])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goAccount()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-book-o"
  }), _vm._v(" Account "), (_vm.mobileConfirmedComp) ? _c('label', {
    staticClass: "badge badge-error"
  }, [_vm._v("1")]) : _vm._e()])]), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goFindSitters()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goPetsView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paw"
  }), _vm._v(" Pets")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goCalendar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar "
  }), _vm._v(" Update Calendar ")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
    staticClass: "hidden-md hidden-lg",
    attrs: {
      "tag": "li",
      "to": "/dashboard/feedback-performance"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/my-sitter-reservations"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/sitter-profile-edit/about"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v(" Profile Setup")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goMyReservations()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goFavoriteSitters()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" Favorite Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client' && _vm.subscriptionStatusComp == false) ? _c('li', [_c('a', {
    staticStyle: {
      "color": "green !important"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Subscribe")])]) : _vm._e(), _vm._v(" "), (!_vm.doubleRoleComp) ? _c('li', [_c('a', {
    staticStyle: {
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goBecomeSitter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-weight": "600"
    }
  }), _vm._v(" Become a Sitter")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goToSitterProfile()
      }
    }
  }, [_vm._v("View Public Profile")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "padding": "0px",
      "margin": "0px"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Sign Out")])])], 1)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('div', [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/charts-dashboard"
    }
  }, [_c('a', [_vm._v(" Charts Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitters-dashboard"
    }
  }, [_c('a', [_vm._v(" Sitters Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/bookings-dashboard"
    }
  }, [_c('a', [_vm._v(" Bookings Dashboard")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown pull-right"
  }, [(_vm.compUserName) ? _c('a', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "margin-left": "3px"
    },
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "img img-rounded",
    staticStyle: {
      "width": "auto",
      "height": "50px",
      "max-height": "5vh"
    },
    attrs: {
      "alt": "User Profile Picture",
      "src": _vm.compProfilePicUrl,
      "crossOrigin": "Anonymous"
    }
  }), _vm._v(" "), _c('a', [_vm._v(" " + _vm._s(_vm.compUserName))])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goAccount()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-book-o"
  }), _vm._v(" Account")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/users-dashboard"
    }
  }, [_c('a', [_vm._v(" Users Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/charts-dashboard"
    }
  }, [_c('a', [_vm._v(" Charts Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/sitters-dashboard"
    }
  }, [_c('a', [_vm._v(" Sitters Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/bookings-dashboard"
    }
  }, [_c('a', [_vm._v(" Bookings Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/tickets-dashboard"
    }
  }, [_c('a', [_vm._v(" Tickets Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/email-dashboard"
    }
  }, [_c('a', [_vm._v(" Custom Email Dashboard")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "padding": "0px",
      "margin": "0px"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Sign Out")])])], 1)])], 1)]) : _vm._e()])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default navbar-static-top paw hidden-sm hidden-md hidden-lg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkUser),
      expression: "checkUser"
    }],
    staticClass: "navbar-toggle pull-right notification-button",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "mobileNotificationDropdown"
    },
    on: {
      "click": function($event) {
        _vm.closeNavbarIfOpen()
      }
    }
  }, [_c('Notifications', {
    attrs: {
      "bindId": _vm.mobileDropdown
    }
  })], 1), _vm._v(" "), (_vm.compUserRole == 'Sitter') ? _c('span', {
    staticClass: "navbar-toggle pull-right bookings-button",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('router-link', {
    staticStyle: {
      "list-style-type": "none"
    },
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/my-sitter-reservations"
    }
  }, [_c('i', {
    staticClass: "icon-fix fa fa-bookmark-o"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client') ? _c('span', {
    staticClass: "navbar-toggle pull-right bookings-button",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('router-link', {
    staticStyle: {
      "list-style-type": "none"
    },
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/my-reservations"
    }
  }, [_c('i', {
    staticClass: "icon-fix fa fa-bookmark-o"
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.checkUser) ? _c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showCountries()
      }
    }
  }, [_c('i', [_c('img', {
    staticClass: "img img-rounded",
    staticStyle: {
      "text-indent": "-9999px",
      "width": "auto",
      "height": "30px",
      "margin-top": "10px",
      "margin-right": "10px",
      "max-height": "5vh"
    },
    attrs: {
      "alt": "CF",
      "src": _vm.countryDataComp.CountryFlag,
      "crossOrigin": "Anonymous"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.routerGoHome()
      }
    }
  }, [_vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('div', [(_vm.checkUser == true) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goAccount()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-book-o"
  }), _vm._v(" Account "), (_vm.mobileConfirmedComp) ? _c('label', {
    staticClass: "badge badge-error"
  }, [_vm._v("1")]) : _vm._e()])]), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goFindSitters()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.customer) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goPetsView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paw"
  }), _vm._v(" My Pets")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goSitterProfileEdit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v(" Profile Setup")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goSitterReservations()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v("  Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goCalendar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar "
  }), _vm._v(" Update Calendar ")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goDashboard()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-globe "
  }), _vm._v(" Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.customer) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goMyReservations()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.customer) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goFavoriteSitters()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" My Favorite Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.customer) ? _c('li', [_c('a', {
    staticClass: "text-success",
    staticStyle: {
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goBecomeSitter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-weight": "600"
    }
  }), _vm._v(" Become a Sitter")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client' && _vm.subscriptionStatusComp == false) ? _c('li', [_c('a', {
    staticStyle: {
      "color": "green"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Subscribe")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Sitter' && _vm.subscriptionStatusComp == false && !_vm.singaporeComp) ? _c('li', [_c('a', {
    staticStyle: {
      "color": "rgb(147, 111, 159) !important"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paw"
  }), _vm._v(" Go Premium")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goToSitterProfile()
      }
    }
  }, [_vm._v("View Public Profile")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goUsersDashboard()
      }
    }
  }, [_vm._v("Users Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goSittersDashboard()
      }
    }
  }, [_vm._v("Sitters Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goBookingsDashboard()
      }
    }
  }, [_vm._v("Bookings Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goChartsDashboard()
      }
    }
  }, [_vm._v("Charts Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goTicketsDashboard()
      }
    }
  }, [_vm._v("Tickets Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goCustomEmailDashboard()
      }
    }
  }, [_vm._v("Custom Email Dashboard")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "padding": "0px",
      "margin": "0px"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Sign Out")])])]) : _vm._e(), _vm._v(" "), (!_vm.checkUser) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_vm._m(4), _vm._v(" "), (_vm.checkUser == false) ? _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/login"
    }
  }, [_c('a', [_vm._v("Sign In")])]) : _vm._e(), _vm._v(" "), (_vm.checkUser == false) ? _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/findsitters"
    }
  }, [_c('a', [_vm._v(" Search Sitters "), _c('i', {
    staticClass: "fa fa-search"
  })])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/become-a-sitter"
    }
  }, [_c('a', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("Become a Sitter "), _c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-weight": "600"
    }
  })])]) : _vm._e()], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.mobileConfirmedComp && _vm.compUserRole != 'Sitter') ? _c('div', {
    staticClass: "hidden-xs hidden-sm alert text-center alert-dismissible alert-success",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-top": "5px",
      "padding-bottom": "5px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "h4"
  }, [_c('i', {
    staticClass: " fa fa-bell-o",
    class: {
      'animated swing': _vm.reminderClass
    }
  }), _vm._v("  Please verify your Mobile number to receive SMS updates, visit "), _c('a', {
    staticClass: "h4",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goAccount()
      }
    }
  }, [_c('strong', [_vm._v("Account")])])])]) : _vm._e(), _vm._v(" "), (_vm.mobileConfirmedComp && _vm.compUserRole != 'Sitter') ? _c('div', {
    staticClass: "hidden-lg hidden-md alert text-center alert-dismissible alert-success",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-top": "5px",
      "padding-bottom": "5px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', {
    staticClass: "h4"
  }, [_c('i', {
    staticClass: " fa fa-bell-o",
    class: {
      'animated swing': _vm.reminderClass
    }
  }), _vm._v("  Verify Mobile to get SMS updates "), _c('a', {
    staticClass: "h4",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goAccount()
      }
    }
  }, [_c('strong', [_vm._v("Account")])])])]) : _vm._e(), _vm._v(" "), (_vm.sitterPremiumComp == false) ? _c('div', {
    staticClass: "hidden-xs hidden-sm alert text-center alert-dismissible alert-info",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-top": "5px",
      "padding-bottom": "5px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.hidePremium()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('span', {
    staticClass: "h4",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_vm._v("Go Premium "), _c('i', {
    staticClass: " fa fa-paw",
    class: {
      'animated bounceIn': _vm.reminderClass
    },
    staticStyle: {
      "font-size": "20px"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.sitterPremiumComp == false) ? _c('div', {
    staticClass: "hidden-lg hidden-md alert text-center alert-dismissible alert-info",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-top": "5px",
      "padding-bottom": "5px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.hidePremium()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('span', {
    staticClass: "h4",
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_vm._v(" Go Premium "), _c('i', {
    staticClass: " fa fa-paw",
    class: {
      'animated pulse': _vm.reminderClass
    },
    staticStyle: {
      "font-size": "20px"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "page-footer paw-footer",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container-fluid main-footer"
  }, [_c('div', {
    staticClass: "container center-block"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('h4', {
    staticClass: "text-muted small-h4"
  }, [_vm._v("Quick Links")]), _vm._v(" "), (!_vm.doubleRoleComp) ? _c('h5', [_vm._m(7)]) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), (_vm.checkUser != true) ? _c('h5', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    }
  }, [_vm._v("Sign In")])]) : _vm._e(), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goToSupport()
      }
    }
  }, [_vm._v(" Contact Support "), _c('i', {
    staticClass: "fa fa-support"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('h4', {
    staticClass: "text-muted small-h4"
  }, [_vm._v("Dupaws Info")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goTerms()
      }
    }
  }, [_vm._v("Terms and Conditions")])]), _vm._v(" "), _c('h5', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goPrivacy()
      }
    }
  }, [_vm._v("Privacy Policy")])])]), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "container text-center text-muted"
  }, [_c('br'), _vm._v(" "), _c('hr', {
    staticStyle: {
      "max-width": "600px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "margin-left": "-4px"
    }
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_vm._v("Send link to a friend")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_top",
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.shareFacebook(_vm.myQuoteComp)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x social",
    attrs: {
      "id": "social-fb"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_top",
      "href": _vm.twitterUrl
    },
    on: {
      "click": function($event) {
        _vm.shareTwitter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x social",
    attrs: {
      "id": "social-tw"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_top",
      "href": _vm.linkedinUrl
    },
    on: {
      "click": function($event) {
        _vm.shareLinkedin()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x social",
    attrs: {
      "id": "social-ln"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_top",
      "href": _vm.googleUrl
    },
    on: {
      "click": function($event) {
        _vm.shareGooglePlus()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus fa-2x social",
    attrs: {
      "id": "social-gp"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "hidden-md hidden-lg",
    attrs: {
      "href": _vm.whatsappUrl,
      "data-action": "share/whatsapp/share"
    },
    on: {
      "click": function($event) {
        _vm.shareWhatsApp()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp fa-2x social",
    attrs: {
      "id": "social-wa"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#fd7e14"
    },
    attrs: {
      "target": "_top",
      "href": _vm.mailUrl
    },
    on: {
      "click": function($event) {
        _vm.shareMail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-square fa-2x social",
    attrs: {
      "id": "social-em"
    }
  })])])]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted"
  }, [_vm._v("All rights reserved © Dupaws.com 2018")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Please choose your country")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hidden-sm"
  }, [_c('a', {
    staticClass: "navbar-link",
    attrs: {
      "href": "https://www.dupaws.com/pub/about"
    }
  }, [_vm._v(" About Us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "navbar-brand"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Dupaws Home",
      "src": require("./components/Sitters/images/Logo_small.png"),
      "height": "46"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "navbar-link",
    attrs: {
      "href": "https://www.dupaws.com/pub/about"
    }
  }, [_vm._v(" About Us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "font-weight": "600"
    },
    attrs: {
      "href": "/become-a-sitter"
    }
  }, [_vm._v(" Become a Sitter "), _c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-weight": "600",
      "font-size": "smaller"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/findsitters"
    }
  }, [_vm._v(" Search Sitters "), _c('i', {
    staticClass: "fa fa-search"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/reviews"
    }
  }, [_vm._v("Customer Reviews")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/training"
    }
  }, [_vm._v("Brain Dog Training")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/about"
    }
  }, [_vm._v("About Us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/faq"
    }
  }, [_vm._v("Frequently Asked Questions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('a', {
    attrs: {
      "href": "mailto:info@dupaws.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" info@dupaws.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6 remove-margins"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('h4', {
    staticClass: "text-muted small-h4"
  }, [_vm._v("Top Countries ")]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/united-arab-emirates"
    }
  }, [_vm._v(" United Arab Emirates ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/lebanon"
    }
  }, [_vm._v(" Lebanon ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/qatar"
    }
  }, [_vm._v(" Qatar")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/bahrain"
    }
  }, [_vm._v(" Bahrain")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/singapore"
    }
  }, [_vm._v(" Singapore")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/kuwait"
    }
  }, [_vm._v(" Kuwait")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('h4', {
    staticClass: "text-muted small-h4"
  }, [_vm._v("Top Cities")]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-dubai"
    }
  }, [_vm._v("  Dubai ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-abu-dhabi"
    }
  }, [_vm._v("  Abu Dhabi ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-sharjah"
    }
  }, [_vm._v(" Sharjah ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/qatar/dog-boarding-in-doha"
    }
  }, [_vm._v("  Doha ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/lebanon/dog-boarding-in-beirut"
    }
  }, [_vm._v(" Beirut")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/sitters/jordan/dog-boarding-in-amman"
    }
  }, [_vm._v("  Amman")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ca1428a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 611
// module chunks = 2